<template>
	<div class="change-agent-content">
		<el-dialog
			title="店铺圈选结果"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			:before-close="handleClose"
			width="700px"
		>
			<span slot="title">
				<div class="title">店铺圈选结果</div>
				<img
					class="icon-s delete-btn"
					src="@/assets/images/delete.png"
					@click="handleRemove"
					alt=""
				/>
			</span>
			<el-table
				border
				height="450"
				:data="agentList"
				:header-cell-style="{
					background: 'rgba(200, 204, 215,.6)',
					color: '#333333'
				}"
				@select-all="handleSelectAll"
				@select="handleSelect"
			>
				<el-table-column
					type="selection"
					width="50"
					align="center"
				>
				</el-table-column>
				<el-table-column prop="agentName" label="店铺简称" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="sapAgentNo" width="140" label="SAP编号" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="routeName" width="120" label="当前路线" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="channelName" width="70" label="渠道" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="allSku" width="55" label="累计" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="allDaver" width="55" label="日均" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>
			<ul class="footer">
				<li>
					<el-button size="small" type="primary" @click="handleAddRoute">
						创建新路线
					</el-button>
				</li>
				<li>
					<el-button size="small" type="primary" @click="handleChangeRoute">
						变更路线
					</el-button>
				</li>
				<li>
					<el-button size="small" type="primary" @click="handleDeleteAgentAll">
						从当前路线中移除
					</el-button>
				</li>
			</ul>
		</el-dialog>
		<!-- 变更路线 -->
		<changeRoute ref="changeRoute" @changeRoute="changeRoute" @handleClose="handleClose"></changeRoute>
		<!-- 新增路线 -->
		<addRoute ref="addRoute" @changeRoute="changeRoute" @handleClose="handleClose"></addRoute>
	</div>
</template>
<script>
import changeRoute from "./change-route.vue";
import addRoute from "./add-route.vue";
export default {
	components: {
		changeRoute,
		addRoute
	},
	data() {
		return {
			dialogVisible: false,
			// 当前组织机构
			groupId: [],
			// 圈选店铺列表
			agentList: [],
			// 选中的店铺
			selection: []
		};
	},
	methods: {
		init(agentList, groupId) {
			this.$nextTick(() => {
				let changeAgents = [];
				for (const agent of agentList) {
					changeAgents.push({
						routeId: agent.routeId,
						agentId: agent.agentId
					})
				}
				this.groupId = groupId;
				// 获取圈选店铺数据
				this.$request
					.post("routeMapSelectAgent", true, {
						changeAgents: changeAgents
					})
					.then(res => {
						let nokey = 0;
						for (const iterator of res.data) {
							nokey++;
							iterator.allSku = iterator?.agentLmaverPivot?.allSku || '';
							iterator.allDaver = iterator?.agentLmaverPivot?.allDaver || '';
							iterator.nokey = nokey;
						}
						this.agentList = res.data;
						this.dialogVisible = true;
					});
			});
		},
		// 全选
		handleSelectAll(selection) {
			this.selection = selection;
		},
		// 单选
		handleSelect(selection, row) {
			this.selection = selection;
		},
		// 新增路线
		handleAddRoute() {
			this.$refs.addRoute.init(this.agentList, this.groupId);
		},
		// 变更路线回调接口
		changeRoute() {
			this.$emit("changeRoute");
		},
		// 变更路线
		handleChangeRoute() {
			this.$refs.changeRoute.init(this.agentList, this.groupId);
		},
		// 移除店铺
		handleRemove() {
			if(this.selection.length == 0) {
				return
			}
			this.$confirm("确认要将选中店铺从圈选结果中移出吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					if(res.code == "0") {
						let agentIds = this.selection.map(obj => obj.nokey);
						if(agentIds.length == this.agentList.length) {
							this.handleClose();
							return
						}
						this.agentList = this.agentList.filter(item => !agentIds.includes(item.nokey));
						this.$message({
							type: "success",
							message: "移除成功!"
						});
					}
				})
				.catch(() => {

				});
		},
		// 删除圈选的所有店铺
		handleDeleteAgentAll() {
			this.$confirm("确认要从现路线中移除吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					let changeAgents = [];
					for (const agent of this.agentList) {
						changeAgents.push({
							routeId: agent.routeId,
							agentId: agent.agentId
						})
					}
					this.$request
						.post("routeMapDeleteAgent", true, {
							changeAgents: changeAgents
						})
						.then(res => {
							if(res.code == "0") {
								// 移除地图绘制的圈选
								this.$emit("handleCancelDraw");
								this.$emit("deleteAgent");
								this.$message({
									type: "success",
									message: "移除成功!"
								});
								this.dialogVisible = false;
							}
						});
				})
				.catch(() => {

				});
		},
		// 关闭页面调用
		handleClose() {
			// 移除地图绘制的圈选
			this.$emit("handleCancelDraw");
			this.dialogVisible = false;
		}
	}
};
</script>
<style lang="scss" scoped>
.delete-icon {
	width: 24px;
	height: 24px;
	cursor: pointer;
}
.footer {
	margin-top: 20px;
	display: flex;
	li {
		flex: 1;
		list-style: none;
		text-align: center;
	}
}
.el-table {
	// 深度选择器，去除默认的padding
	/deep/ th {
		padding: 0px;
		line-height: 34px;
	}

	/deep/ td {
		padding: 5px;
	}

	/deep/ .warning-row {
		background: #f1f1f5;
	}
	/deep/ th .el-table__cell {
		padding: 0 !important;
	}
}
.delete-btn{
	float: right;
    margin-right: 30px;
    margin-top: -24px;
	cursor: pointer;
}
</style>
